import React, { memo } from 'react';
import { Box, Skeleton } from '@ublend-npm/aulaui-core';
import {
  SPACE_CARD_DESCRIPTION_HEIGHT_PX,
  SPACE_CARD_INNER_WIDTH_PX,
  SPACE_CARD_PROGRESS_SECTION_GAP_PX,
  SPACE_CARD_PROGRESS_SECTION_HEIGHT_PX,
  SPACE_CARD_SKELETON_SURFACE,
  SPACE_ENGAGEMENT_LINK_HEIGHT_PX,
  SPACE_PROGRESS_BAR_HEIGHT_PX,
  SPACE_PROGRESS_LABEL_HEIGHT_PX,
} from './spaceWidgetConstants';

type SpaceCardContentRefreshSkeletonProps = {
  isStudent: boolean;
  skeletonSurface?: string;
};

const SpaceCardContentRefreshSkeleton = ({
  isStudent,
  skeletonSurface = SPACE_CARD_SKELETON_SURFACE,
}: SpaceCardContentRefreshSkeletonProps) => (
  <Box aria-hidden data-testid="space-card-content-refresh-skeleton">
    <Skeleton
      kind="rounded"
      height={SPACE_CARD_DESCRIPTION_HEIGHT_PX}
      sx={{
        width: `${SPACE_CARD_INNER_WIDTH_PX}px`,
        borderRadius: '6px',
        bgcolor: skeletonSurface,
      }}
    />

    {isStudent ? (
      <Box
        sx={{
          width: `${SPACE_CARD_INNER_WIDTH_PX}px`,
          height: `${SPACE_CARD_PROGRESS_SECTION_HEIGHT_PX}px`,
          display: 'flex',
          flexDirection: 'column',
          gap: `${SPACE_CARD_PROGRESS_SECTION_GAP_PX}px`,
          flexShrink: 0,
          mt: `${SPACE_CARD_PROGRESS_SECTION_GAP_PX}px`,
        }}
      >
        <Skeleton
          kind="rounded"
          height={SPACE_PROGRESS_BAR_HEIGHT_PX}
          sx={{
            width: '100%',
            borderRadius: '999px',
            bgcolor: skeletonSurface,
          }}
        />
        <Skeleton
          kind="rounded"
          height={SPACE_PROGRESS_LABEL_HEIGHT_PX}
          sx={{
            width: '42%',
            borderRadius: '6px',
            bgcolor: skeletonSurface,
          }}
        />
      </Box>
    ) : (
      <Skeleton
        kind="rounded"
        height={SPACE_ENGAGEMENT_LINK_HEIGHT_PX}
        sx={{
          width: `${SPACE_CARD_INNER_WIDTH_PX}px`,
          borderRadius: '6px',
          bgcolor: skeletonSurface,
          mt: `${SPACE_CARD_PROGRESS_SECTION_GAP_PX}px`,
        }}
      />
    )}
  </Box>
);

export default memo(SpaceCardContentRefreshSkeleton);
